"use client"

import type { BannerCarouselProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { BannerCarouselContent } from "./components/BannerCarouselContent"
import { useBannerCarousel } from "./hooks/useBannerCarousel"

export const RenderConfig: ComponentConfig<BannerCarouselProps> = {
  render: ({ banners, className, styles, responsiveType, id: componentId }: BannerCarouselProps & { id?: string }) => {
    const { id } = useBannerCarousel({
      banners,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <BannerCarouselContent id={id} banners={banners} className={twMerge(className)} />
      </>
    )
  },
}
